import { Button, Center } from '@mantine/core';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useRouteError } from 'react-router-dom';

import { IconFigmaArrowLeft, IconFigmaRotate } from '@/assets/icons';
import { ErrorCard } from '@/pages/ErrorCard';
import { sendClientLog } from '@/utils/clientLog';

export const ErrorPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const error = useRouteError();

  useEffect(() => {
    console.error('[ErrorPage] Uncaught render error:', error);
    sendClientLog({
      level: 'error',
      context: 'ErrorPage',
      message: error instanceof Error ? error.message : String(error)
    });
  }, [error]);

  return (
    <Center h="100dvh" p={16} style={{ backgroundColor: 'var(--color-bg-canvas)' }}>
      <ErrorCard
        badge={t('errorPage.badge')}
        title={t('errorPage.title')}
        message={t('errorPage.message')}
        actions={
          <>
            <Button
              fullWidth
              rightSection={<IconFigmaRotate size={18} />}
              onClick={() => window.location.reload()}
            >
              {t('errorPage.retry')}
            </Button>
            <Button
              fullWidth
              variant="outline"
              leftSection={<IconFigmaArrowLeft size={18} />}
              onClick={() => navigate('/login')}
            >
              {t('errorPage.backLogin')}
            </Button>
          </>
        }
      />
    </Center>
  );
};
